<fieldset>
  <div class="form-group" [class.row]="!detailViewComponent.smallScreen">
    <div class="mb-sm-1 col-12">
      <div class="input-group-sm">
        <div class="form-control divider-field">
          <div class="divider-line"></div>
        </div>
      </div>
    </div>
  </div>
</fieldset>
